import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {unsplashStore} from '@components/board-appearance/unsplash/unsplash-store'
import {LinkButton} from '@components/common/base/buttons'
import {Loader} from '@components/common/base/loader'
import {TwListItemButton} from './containers'

export const UnsplashSkinsButton = observer(() => {
  const {currentPage, totalPages, wait} = unsplashStore.state

  if (wait) {
    return (
      <TwListItemButton>
        <Loader size="small" />
      </TwListItemButton>
    )
  }

  if (currentPage < totalPages && currentPage !== 0) {
    return (
      <TwListItemButton>
        <LinkButton
          onClick={() => {
            unsplashStore.setWait(true)
            void unsplashStore.requestNextPage()
          }}
          noPaddings
        >
          <div>{Lang.msg.showMore31}</div>
          <div>{Lang.msg.showMore32}…</div>
        </LinkButton>
      </TwListItemButton>
    )
  }

  return null
})
